import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featuredVideos = videos.filter((v) => v.featured);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑精选，品质保证</p>
          </div>
          <Link
            to="/category/91-video"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-black/60 text-white text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                    {video.quality}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/80 text-white text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                    {video.rating}分
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-black/60 text-white text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{video.categoryName}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{video.year}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {video.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {video.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </div>
                    {video.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}